import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Skeleton } from 'primereact/skeleton';
import { DataTable } from 'primereact/datatable';
import { Tooltip } from 'primereact/tooltip';
import { Column } from 'primereact/column';
import { FilterMatchMode } from 'primereact/api';
import { Message } from 'primereact/message';
import Conexao from '../../../providers/Conexao';
import Layout from '../../Layout';
import fontConfig from '../../../Componentes/FontConfig';
import { useLocation } from 'react-router-dom';
import { OverlayPanel } from 'primereact/overlaypanel';
import { SplitButton } from 'primereact/splitbutton';
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { Sidebar } from 'primereact/sidebar';
import { Dropdown } from 'primereact/dropdown';
import { Divider } from 'primereact/divider';
import { Tag } from 'primereact/tag';
import { InputSwitch } from "primereact/inputswitch";
import ModalAlterarSenha from './ModalAlterarSenha';
import ModalNovaRevenda from './ModalNovaRevenda';
import { ProgressSpinner } from 'primereact/progressspinner';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import BotaoEngrenagem from '../../../Componentes/BotaoEngrenagem';
import { SpeedDial } from 'primereact/speeddial';
import SidebarRevendas from './SidebarRevendas';
import ModalEdicaoRevenda from './ModalEdicaoRevenda';

export default function Revendas(props) {
    
    const toast = React.useRef(null); // Ref para o Toast
    
    const [loading, setLoading] = useState(false);

    const [empresas, setEmpresas] = useState([]);

    const [verInativos, setVerInativos]= useState(false);

    const [months, setMonths] = useState([]);

    const [selectedMonth, setSelectedMonth] = useState(null);

    const [fieldsFound, setFieldsFound] = useState([]);

    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const location = useLocation();

    const { dataEmpresa } = location.state || {};

    const firstGet = useRef(false)

    const [bloqueada, setBloqueada]= useState(false);


    const [filters, setFilters] = useState({
        global  :   { value: null, matchMode: FilterMatchMode.CONTAINS },
        idusuario:  { value: '', matchMode: FilterMatchMode.CONTAINS },
        cpf_cnpj:   { value: '', matchMode: FilterMatchMode.EQUALS },
        nome    :   { value: '', matchMode: FilterMatchMode.STARTS_WITH },
        cidade  :   { value: '', matchMode: FilterMatchMode.CONTAINS },
        estado  :   { value: '', matchMode: FilterMatchMode.EQUALS },
        ativo   :   { value: 't', matchMode: FilterMatchMode.EQUALS }
    });

    useEffect(() => {

        setFilters(prevFilters => ({
            ...prevFilters,
            ativo: verInativos ? { value: null, matchMode: FilterMatchMode.EQUALS } : { value: 't', matchMode: FilterMatchMode.EQUALS }
        }));

    }, [verInativos]);

    useEffect(() => {

       setBloqueada(dataEmpresa.bloqueiofinanceiro) 

    }, [dataEmpresa.bloqueiofinanceiro]);
   
    useEffect(() => {
        
           if(!firstGet.current){
               firstGet.current = true
               getData();
           }

       }, []);

    const getData = () => {
       
        clearFilters(verInativos)

        setLoading(true);

        Conexao.post('empresasController/getRevendas?idusuario=' + dataEmpresa.idrevenda, { filtro: "todos", tipoFiltro: "", ativo : "todos" })
        .then(response => {

            if (response.status === 200 && response.data.status === 'OK') {
        
                setEmpresas(response.data.payload);

                setLoading(false);

            } else {

                setEmpresas([])

                setLoading(false);

                showMessageToast('warn', "Não foi possível recuperar dados")

            }

        }).catch(error => {

            setEmpresas([])

            setLoading(false);

            showMessageToast('error', "erro ao recuperar dados")

        });

    };

    const onGlobalFilterChange = (e) => {

        const value = e.target.value;

        setGlobalFilterValue(value);
            
        const _filters = { ...filters };// Atualizar o filtro global

        _filters['global'].value = value;

        setFilters(_filters);    
        
        const foundFields = []; // Identificar os campos onde o filtro foi encontrado
      
        const fields = ['idusuario', 'cpf_cnpj', 'nome', 'cidade', 'estado']; // Verificando em cada campo se o filtro global está presente

        fields.forEach(field => {

            const fieldValue = empresas.map(empresa => empresa[field]?.toString().toLowerCase());

            const matches = fieldValue.some(val => val.includes(value.toLowerCase()));

            if (matches) {

                foundFields.push(field); // Adiciona o campo encontrado

            }

        });
    
        setFieldsFound(foundFields); // Atualiza o estado com os campos encontrados
    };
    
    const renderStatusRow= (row, opcao) => {

        return (
            row.habilitarcobranca =='t' ? <><Tooltip target=".tagAtiva-tooltip" content="Esta Empresa esta ATIVA" position="top" />
                                <div style ={{ textAlign :'center', backgroundColor : '#80CBC4', width : '100%', border : 'solid 1px #2E7D32', color: '#fff', fontSize : '11px', padding : '3px',
                                 paddingLeft : '5px', paddingRight : '5px', borderRadius : '5px'}}
                                 >CONTRATO</div></> : <><Tooltip target=".tagIntiva-tooltip" content="Esta Empresa esta TESTE" position="top" />
            <div style ={{textAlign :'center',backgroundColor : '#EF9A9A', width : '100%', border : 'solid 1px #f00', color: '#fff', fontSize : '11px', padding : '3px', paddingLeft : '5px', paddingRight : '5px', borderRadius : '5px'}} >
                TESTE</div></>
        );
    };

    
    /*
    useEffect(() => {//empresasController/disableEmpresa?idusuario=77&status=t

        const currentYear = new Date().getFullYear();

        const currentMonth = new Date().getMonth() + 1; // getMonth() retorna 0-11

        const meses = Array.from({ length: currentMonth }, (_, i) => {

            const month = (i + 1).toString().padStart(2, "0");

            return { label: `${month}-${currentYear}`, value: `${currentYear}-${month}-01` };

        });

        setMonths(meses);

    }, []);
    */

    useEffect(() => {
    const now = new Date();
    const meses = [];

    for (let i = 5; i >= 0; i--) {
        const date = new Date(now.getFullYear(), now.getMonth() - i, 1);

        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        meses.push({
            label: `${month}-${year}`,
            value: `${year}-${month}-01`
        });
    }

    setMonths(meses);
}, []);


    const renderHeader = () => {
        return (
            <div className="flex justify-content-between align-items-center" style={{paddingBottom : '10px', paddingTop : '30px', paddingLeft : '0px'}}>
               
                <div className="flex align-items-center gap-2">
                    <IconField iconPosition="left">
                        <InputIcon className="pi pi-search" />
                        <InputText 
                            value={globalFilterValue} 
                            onChange={onGlobalFilterChange} 
                            placeholder="Pesquisa global" 
                            tooltip="Pesquise por qualquer campo da tabela" tooltipOptions={{ position: 'bottom' }}
                        />
                    </IconField>

                    <Button 
                        icon="pi pi-filter-slash" 
                        className="p-button-secondary p-button-sm" 
                        onClick={clearFilters} 
                        tooltip="Limpar todos os filtros" tooltipOptions={{ position: 'bottom' }}
                    />
                    
                    <Button 
                        icon="pi pi-sync" 
                        className= "p-button-primary p-button-sm" 
                        onClick={getData} 
                        tooltip="Buscar dados..." tooltipOptions={{ position: 'bottom' }}
                    /> 

                    <ModalNovaRevenda  showMessage = {showMessageToast} setRevenda ={(data)=>{
                        /*setEmpresas((prevData)=>[{
                            ...prevData, 
                            data
                        }])*/
                        setEmpresas((prevData) => [...prevData, data]);
                    }}/>
                    
                <Dropdown
                        value={selectedMonth}
                        onChange={(e) => setSelectedMonth(e.value)}
                        options={months}
                        placeholder="Selecione um mês"
                        className="w-full md:w-14rem"
                    />
               {dataEmpresa.idempresa === 31 ?  <Button 
                        icon="pi pi-key" 
                        disabled ={dataEmpresa.idempresa !== 31}
                        className= "p-button-secondary p-button-sm" 
                        severity={bloqueada === 't' ? 'success' : 'danger'}
                        label={bloqueada === 't' ? 'Desbloquear Acesso' : 'Bloquear Acesso'}
                        onClick={()=>{
                            confirmDialog({
                                        message: dataEmpresa.bloqueiofinanceiro === 't' ? 'Desativar o Bloqueio financeiro agora?' : 'Ativar o Bloqueio financeiro agora?',
                                        header: 'Confirmação',
                                        icon: 'pi pi-exclamation-triangle',
                                        acceptLabel: 'Sim',
                                        rejectLabel: 'Não',
                                        accept: () => {

                                            Conexao.post('usuariosController/habilitarBloqueioFinanceiro?opcao=', {
                                                status : (bloqueada === 't' ? 'f' : 't')

                                            }).then(response=>{

                                                if (response.status === 200 && response.data.status === 'OK') {

                                                    if(bloqueada === 't' ){

                                                        showMessageToast('success', 'Empresa HABILITADA com sucesso');
                                                        setBloqueada('f')

                                                    }else{

                                                        showMessageToast('error', 'Empresa DESABILITADA com sucesso');
                                                        setBloqueada('t')

                                                    }
                                                    
                                                
                                                } else {

                                                    showMessageToast('warn', 'Não foi possível alterar o status da empresa!');
                                                    

                                                }

                                            }).catch(error=>{

                                                    showMessageToast('danger', 'Não foi possível alterar o status da empresa!');

                                            })

                                        }})
                        }

                            
                    }
                        tooltip="Buscar dados..." tooltipOptions={{ position: 'bottom' }}
                    />     : null }
                </div>
                <div className="flex flex-column align-items-start mb-2">
                    <span className="text-small">Inativos</span>
                    <InputSwitch checked={verInativos}
                        onChange={() => {
                            setVerInativos(prev => !prev)
                        }
                            
                        }/>
                </div>
            </div>
        );
    };
    

    const renderFooter = () => {

        if (fieldsFound.length === 0) {
            return  <div className="w-10 text-left" style={{ fontSize: '10px', color: '#444' }}>
            Total de registros: {empresas.length} 
        </div>
        }
        
        return <>

        <div className="w-10 text-left" style={{ fontSize: '10px', color: '#444' }}>
            Total de registros: {empresas.length} 
        </div>

        <div className="w-10 text-left" style={{ fontSize: '10px', color: '#444' }}>
            Filtro encontrado em: {fieldsFound.join(', ')}
        </div>
    </>
    };
/*
    const clearFilters = (statusAtivo) => {

        setGlobalFilterValue('');

        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            idusuario: { value: '', matchMode: FilterMatchMode.CONTAINS },
            cpf_cnpj: { value: '', matchMode: FilterMatchMode.EQUALS },
            nome: { value: '', matchMode: FilterMatchMode.STARTS_WITH },
            cidade: { value: '', matchMode: FilterMatchMode.CONTAINS },
            estado: { value: '', matchMode: FilterMatchMode.EQUALS },
            ativo: statusAtivo ? { value: null, matchMode: FilterMatchMode.EQUALS } : { value: 't', matchMode: FilterMatchMode.EQUALS }
        });

        setFieldsFound([]); // Resetando os campos encontrados

    };
*/

const clearFilters = (statusAtivo = verInativos) => {

    setGlobalFilterValue('');

    setFilters({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        idusuario: { value: '', matchMode: FilterMatchMode.CONTAINS },
        cpf_cnpj: { value: '', matchMode: FilterMatchMode.EQUALS },
        nome: { value: '', matchMode: FilterMatchMode.STARTS_WITH },
        cidade: { value: '', matchMode: FilterMatchMode.CONTAINS },
        estado: { value: '', matchMode: FilterMatchMode.EQUALS },
        ativo: statusAtivo 
            ? { value: null, matchMode: FilterMatchMode.EQUALS } 
            : { value: 't', matchMode: FilterMatchMode.EQUALS }
    });

    setFieldsFound([]);

};  

    const showMessageToast = (severity, msg) => {
        switch(severity){
            case "error":
                toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "success":
                toast.current.show({
                    severity: "success",
                    summary: "Sucess",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "warn":
                toast.current.show({
                    severity: "warn",
                    summary: "Warning",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

        }
        
      };

    return (
        <Layout loading={loading}>
            <div className="p-2">
              
                
                <div className="border-round-lg surface-card shadow-0 p-2">
                    {/* Botão para abrir o OverlayPanel */}
                    
                      {
                         bloqueada === 't' ? 
                      
                       <div style={{marginTop : '30px', marginLeft : '10px'}}>
                         <Message  severity="error" 
                            text={<span>Sistema Bloqueado! Alguns recursos não estarão disponíveis. Favor entrar em contato com departamento comercial <strong>Printerconnect</strong>.</span>} />
                            <p>Funções <strong>indisponíveis:</strong></p>
                            <ul>
                                <li>Cadastro de novos Clientes</li>
                                <li>Cadastro de novas Revendas</li>
                                <li>Cadastro de novas Licenças</li>
                                <li>Cadastro de novos DCA's</li>
                                <li>Edição de Clientes</li>
                                <li>Edição de Empresas</li>
                                <li>Edição de DCA's</li>
                            </ul>
                       </div> : null }
                        <DataTable                            
                            header={renderHeader()}  
                            
                            value={empresas}
                            paginator                 
                            rows={20} // Número de itens por página
                            rowsPerPageOptions={[10, 15, 20, 25]} // Opções de páginas
                            responsiveLayout="scroll"
                            paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Registro {first} até {last} de {totalRecords} registro(s)" 
                            tableStyle={{ minWidth: '35rem' }}
                            filters={filters} // Aplicando os filtros
                            multiSortMeta={[
                                { field: "habilitarcobranca", order: -1 },   // 1 = ascendente
                                { field: "nome", order: 1 }     // -1 = descendente
                            ]}
                            sortMode="multiple"   // precisa habilitar
                            filterDisplay="menu" // Exibe os filtros como menu pop-up
                            
                        >
                            <Column 
                                bodyStyle={{ fontSize: '12px', width : '6%' }} 
                                headerStyle={{ fontSize: '12px' }} 
                                field="idusuario" 
                                header="Código" 
                                body={loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : null}
                                sortable 
                                filter 
                                filterPlaceholder="Filtrar Código" />


                            <Column 
                                header="Status" 
                                sortable
                                field='habilitarcobranca'
                                body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : renderStatusRow(row)} // Passando a função para renderizar o botão de opções
                                bodyStyle={{ position: 'relative' }}  // Ajuste da célula para não causar scroll
                            />


                            <Column 
                                bodyStyle={{ fontSize: '12px' , width : '10%' }} 
                                headerStyle={{ fontSize: '12px' }} 
                                field="cpf_cnpj" header="CPF/CNPJ" 
                                body={loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : null}
                                sortable 
                                filter 
                                filterPlaceholder="Filtrar CPF/CNPJ" />


                            <Column 
                                bodyStyle={{ fontSize: '12px' , width : '40%' }} 
                                headerStyle={{ fontSize: '12px' }} 
                                field="nome" header="Razão Social" 
                                body={loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : null}
                                sortable 
                                filter 
                                filterPlaceholder="Filtrar Razão Social" />


                            <Column 
                                bodyStyle={{ fontSize: '12px' , width : '20%' }} 
                                headerStyle={{ fontSize: '12px' }} 
                                body={loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : null}
                                field="cidade" 
                                header="Cidade" 
                                sortable 
                                filter 
                                filterPlaceholder="Filtrar Cidade" />


                            <Column 
                                bodyStyle={{ fontSize: '12px' , width : '10%' }} 
                                headerStyle={{ fontSize: '12px' }} 
                                field="estado" 
                                body={loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : null}
                                header="UF" 
                                sortable 
                                filter 
                                filterPlaceholder="Filtrar UF" />
                            

                            <Column 
                                header="Senha" 
                                body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : <ModalAlterarSenha  revenda ={row} showMessage = {showMessageToast}/>} // Passando a função para renderizar o botão de opções
                                bodyStyle={{ position: 'relative' }}  // Ajuste da célula para não causar scroll
                            />

                            <Column 
                                header="Editar" 
                                body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : <ModalEdicaoRevenda setRevenda ={(dataRevenda)=>{
                                    console.log(dataRevenda)
                                    setEmpresas((prevData)=>prevData.map((item)=>item.idusuario === dataRevenda.idusuario ? dataRevenda : item))
                                }} revenda ={row} showMessage = {showMessageToast}/>} // Passando a função para renderizar o botão de opções
                                bodyStyle={{ position: 'relative' }}  // Ajuste da célula para não causar scroll
                            />

                            <Column 
                                header="Opções" 
                                body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : 
                                    <SidebarRevendas 
                                        empresa ={row} 
                                        updateRevenda = {(dataRevenda)=>{
                                      
                                            setEmpresas((prevData)=>prevData.map((item)=>item.idusuario === dataRevenda.idusuario ? dataRevenda : item))
                                        }}
                                        showMessage = {showMessageToast}/>} // Passando a função para renderizar o botão de opções
                                bodyStyle={{ position: 'relative' }}  // Ajuste da célula para não causar scroll
                            />
                            <Column 
                                header="Desativar" 
                                body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : <Button 
                                onClick={() => {

                                    confirmDialog({
                                        message: 'Deseja Gerar o relatório de cobrança agora?',
                                        header: 'Confirmação',
                                        icon: 'pi pi-exclamation-triangle',
                                        acceptLabel: 'Sim',
                                        rejectLabel: 'Não',
                                        accept: () => {

                                            Conexao.get('empresasController/desativarRevendaPermanente?idusuario='+row.idusuario).then(response=>{

                                                if (response.status === 200 && response.data.status === 'OK') {

                                                    showMessageToast('success', 'Empresa desabilitada com sucesso');

                                                    setEmpresas((prevData)=>prevData.filter(item => item.idusuario !== row.idusuario));

                                                } else {

                                                    showMessageToast('warn', 'Não foi possível alterar o status da empresa!');

                                                }

                                            }).catch(error=>{

                                                    showMessageToast('danger', 'Não foi possível alterar o status da empresa!');

                                            })

                                        }

                                    });
                                }}
                                severity='danger'
                                icon="pi pi-times" 
                                className= "p-button-primary p-button-sm" 
                                tooltip="Desativar a Revenda" tooltipOptions={{ position: 'bottom' }}
                                />} // Passando a função para renderizar o botão de opções
                                bodyStyle={{ position: 'relative' }}  // Ajuste da célula para não causar scroll
                            />
                            <Column 
                                header="Relatório" 
                                body={(row)=>loading ? <Skeleton height="1.5rem" width="95%" style={{ marginBottom: '10px' }} /> : 
                                <Button severity='secondary' disabled ={row.habilitarcobranca !=='t' || !selectedMonth}  tooltip="Gerar relatório de equipametos monitorados" tooltipOptions={{ position: 'left' }} onClick={()=>{
                                     if(!selectedMonth){
                                        confirmDialog({
                                                message: 'Você precisa definir o mes para gerar o relatório',
                                                header: 'Erro de Relatório',
                                                icon: 'pi pi-exclamation-triangle',
                                                acceptLabel: 'Sim',
                                                rejectLabel: 'Não',
                                                
                                            });

                                            return                                           
                                     }

                                        confirmDialog({
                                                message: 'Deseja Gerar o relatório de cobrança agora?',
                                                header: 'Confirmação',
                                                icon: 'pi pi-exclamation-triangle',
                                                acceptLabel: 'Sim',
                                                rejectLabel: 'Não',
                                                accept: () => {

                                                    var action = btoa("idusuario="+row.idusuario+"&idcliente=-1&tipo=&dataInicial="+selectedMonth);
                                                    var url = "https://datacount.com.br/webapi/index.php/relatoriosController/getDataRelatoriosCobranca?action="+action+'&oauth=9f5c30eab8c4644b5a8da4ddcb263c75';
                                                    window.open(url, '_blank');

                                                }
                                            });
                                }}><i className='pi pi-print' /></Button>} // Passando a função para renderizar o botão de opções
                                bodyStyle={{ position: 'relative' }}  // Ajuste da célula para não causar scroll
                                
                            />
                        </DataTable>
                    
                </div>

               
            </div>
           
                <Toast ref={toast} />

        </Layout>
    );
}
